import { Component, OnInit } from '@angular/core';
import { DeviceService } from '../devices/shared/services/device.service';
import { DeviceList } from '../devices/shared/models/device-list.model';
import { DeviceResponse } from '../devices/shared/models/response/device-response.model';

declare const L: any;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class MapComponent implements OnInit {
  private operationStatusMap: { [id: string]: string } = {};

  constructor(private deviceService: DeviceService) {}

  ngOnInit(): void {
    const initialLatLong = [47.1592, 19.4326];
    const map = L.map('map').setView(initialLatLong, 8);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
    }).addTo(map);

    this.deviceService.getDevicesV2().subscribe((response: DeviceList) => {
      response.szts.forEach((szt) => {
        if (szt.sztExtDeviceId && szt.operationStatus) {
          this.operationStatusMap[szt.sztExtDeviceId] = szt.operationStatus;
        }
      });

      const sztExternalIds = response.szts
        .map((szt) => szt.sztExtDeviceId)
        .filter((id): id is string => !!id);

      this.deviceService
        .getDevicesSensitiveDataByExternalDeviceIds(sztExternalIds)
        .subscribe((responses: DeviceResponse[]) => {
          responses.forEach((deviceData) => {
            const device = deviceData.device;
            const externalDeviceId = device.externalDeviceId;
            const gsmLocationAttr = device.attributes.find(
              (attr) => attr.attributeName === 'gsmLocation'
            );
            const operationStatus = this.operationStatusMap[externalDeviceId];

            if (gsmLocationAttr?.attributeValueString) {
              const [lon, lat, accuracy] = gsmLocationAttr.attributeValueString
                .split(',')
                .map(Number);
              const latLng = [lat, lon];

              const markerColor =
                operationStatus === 'ERROR'
                  ? 'red'
                  : operationStatus === 'WARNING'
                  ? 'yellow'
                  : 'green';

              const icon = L.divIcon({
                className: `marker-${markerColor}`,
                html: `<i class="fas fa-map-marker-alt" style="color:${markerColor}; font-size: 30px;"></i>`,
              });

              L.marker(latLng, { icon })
                .addTo(map)
                .bindPopup(
                  `<strong>Device ID:</strong> ${externalDeviceId}<br><strong>Accuracy:</strong> ${accuracy} meters, status: ${operationStatus}`
                );
            }
          });
        });
    });
  }
}
